<template>
  <div>

    <!-- 標題 bar -->
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">正码走势</span>
        </div>
      </div>
    </div>

    <RadioButtons v-model="select" title="筛选球位" :buttons="filterData" />

    <div v-loading="isLoading" class="ZhengMaZouShi">
      <v-chart ref="polar" :options="line" />
    </div>
  </div>
</template>

<script>
import RadioButtons from '@/components/desktop/common/RadioButtons'
import { getTrand } from '@/api/desktop/trend'

export default {
  name: 'ZhengMaZouShi',
  components: {
    RadioButtons
  },
  data() {
    return {
      isLoading: false,
      data: {},
      filterData: [
        { name: '正码一', val: 1 },
        { name: '正码二', val: 2 },
        { name: '正码三', val: 3 },
        { name: '正码四', val: 4 },
        { name: '正码五', val: 5 },
        { name: '正码六', val: 6 }
      ],
      line: {
        backgroundColor: '#fff',
        color: ['#37A2DA'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          show: false,
          left: 'auto',
          selected: {
            '正码1': true,
            '正码2': false,
            '正码3': false,
            '正码4': false,
            '正码5': false,
            '正码6': false
          }
        },
        xAxis: {
          type: 'category',
          data: [],
          nameLocation: 'middle',
          name: '期号',
          nameTextStyle: {
            fontSize: 24,
            padding: 12,
            height: 4
          },
          axisLabel: {
            interval: 0,
            margin: 8
          }
        },
        yAxis: {
          type: 'value',
          width: 20,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          nameRotate: 0,
          nameLocation: 'middle',
          name: '{x|正\n码\n号\n码}',
          nameTextStyle: {
            rich: {
              x: {
                fontSize: 24,
                padding: 12,
                color: 'black',
                height: 4
              }
            }
          }
        },
        series: [
          {
            name: '正码1',
            type: 'line',
            symbolSize: 8,
            symbol: 'circle',
            smooth: true,
            data: []
          },
          {
            name: '正码2',
            type: 'line',
            symbolSize: 8,
            symbol: 'circle',
            smooth: true,
            data: []
          },
          {
            name: '正码3',
            type: 'line',
            symbolSize: 8,
            symbol: 'circle',
            smooth: true,
            data: []
          },
          {
            name: '正码4',
            type: 'line',
            symbolSize: 8,
            symbol: 'circle',
            smooth: true,
            data: []
          },
          {
            name: '正码5',
            type: 'line',
            symbolSize: 8,
            symbol: 'circle',
            smooth: true,
            data: []
          },
          {
            name: '正码6',
            type: 'line',
            symbolSize: 8,
            symbol: 'circle',
            smooth: true,
            data: []
          }
        ]
      },
      select: 1
    }
  },
  watch: {
    select() {
      this.pickNum(this.select)
    }
  },
  mounted() {
    this.getTrand(this.$route.params.lottery_code, { count: 30 })
    // 自適應
    // window.addEventListener('resize', this.echartResize, false)
    // this.$once('hook:beforeDestroy', () => {
    //   window.removeEventListener('resize', this.echartResize, false)
    // })
  },
  methods: {
    async getTrand(code, query) {
      this.isLoading = true
      const [data, error] = await getTrand(code, query)
      this.isLoading = false
      if (error) {
        console.error(error)
        return
      }
      this.data = data
      this.line.xAxis.data = data.map(el => el.period.length === 10 ? el.period.substr(el.period.length - 4, 4) : el.period.substr(el.period.length - 3, 3))
      data.forEach(per => {
        per.balls.forEach((ball, ballIndex) => {
          if (ballIndex !== 6) {
            this.line.series[ballIndex].data.push(this.padZero(ball))
          }
        })
      })
    },
    // 自適應
    // echartResize() {
    //   this.$refs.polar.resize()
    // },
    pickNum(value) {
      for (let i = 1; i < 7; i++) {
        this.line.legend.selected[`正码${i}`] = false
        if (i === value) {
          this.line.legend.selected[`正码${value}`] = true
        }
      }
    },
    padZero(num) {
      return String(num).padStart(2, '0')
    }
  }
}
</script>

<style lang='scss' scoped>
.ZhengMaZouShi {
  width: 100%;
  height: 500px;
  background-color: white;
}

.echarts {
  width: 100%;
  height: 80%;
}
</style>

